<script setup>
defineProps({
  title: {
    type: String,
    required: true
  },
  headerAction: {
    type: Object,
    default: null
  }
})

const emit = defineEmits(['header-action-click'])
</script>

<template>
  <div class="bcs-card card">
    <div class="bcs-card__header card-header px-4 py-2.5 bg-light d-flex justify-content-between align-items-center">
      <h5 class="bcs-card__title mb-0 header-22">
        <strong>{{ title }}</strong>
      </h5>
      <a
        v-if="headerAction"
        class="hand-cursor text-decoration-none text-14 text-primary"
        @click="emit('header-action-click', headerAction)"
      >
        <strong>
          {{ headerAction.label }}
          <i v-if="headerAction.icon" :class="headerAction.icon" class="ms-2"></i>
        </strong>
      </a>
      <slot name="header-right" />
    </div>
    <div class="bcs-card__body card-body">
      <slot />
    </div>
  </div>
</template>

<style scoped>
.bcs-card__header {
  border-bottom: 1px solid var(--bs-border-color);
}

.hand-cursor {
  cursor: pointer;
}
</style>
